import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
      fill: "#333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 4C5.886 4 3.414 6.87 2.323 8.789a2.43 2.43 0 0 0 0 2.422C3.414 13.13 5.886 16 10 16c4.114 0 6.586-2.87 7.677-4.79a2.43 2.43 0 0 0 0-2.42C16.586 6.87 14.114 4 10 4Zm4 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
      fill: "#333"
    }, null, -1)
  ])))
}
export default { render: render }